import validateForm from './order-functions/validate-form';

declare let party_object: any;

export default class orderParty{

    /**
     * Init
     * @param elForm 
     * @param elFormBtn 
     * @param elWrapPayment 
     * @param elBtnStep 
     * @param elBtnText 
     * @param el_form_process 
     * @param el_payment_element 
     * @param el_loading_payment 
     * @param el_payment_response 
     * @param el_pay_reinit 
     * @param elSpinner 
     */
    init(
        elForm: string,
        elFormBtn: string,
        elWrapPayment: string,
        elBtnStep: string,
        elBtnText: string,
        el_form_process: string,
        el_payment_element: string,
        el_loading_payment: string,
        el_payment_response: string,
        el_pay_reinit: string,
        elSpinner: string,
    ){

        const validate_form = new validateForm(
            elForm,
            elFormBtn,
            elWrapPayment,
            elBtnStep,
            elBtnText,
            el_form_process,
            el_payment_element,
            el_loading_payment,
            el_payment_response,
            el_pay_reinit,
            elSpinner
        );

        validate_form.init();

    }

}